import {
  GET_PACKAGE_ASSIGNMENT_LIST_REQUEST,
  GET_PACKAGE_ASSIGNMENT_LIST_SUCCESS,
  GET_PACKAGE_ASSIGNMENT_LIST_FAILURE,
  APPROVE_PACKAGE_ASSIGNMENT_REQUEST,
  APPROVE_PACKAGE_ASSIGNMENT_SUCCESS,
  APPROVE_PACKAGE_ASSIGNMENT_FAILURE,
  REJECT_PACKAGE_ASSIGNMENT_REQUEST,
  REJECT_PACKAGE_ASSIGNMENT_SUCCESS,
  REJECT_PACKAGE_ASSIGNMENT_FAILURE,
  BULK_APPROVE_ASSIGNMENTS_REQUEST,
  BULK_APPROVE_ASSIGNMENTS_SUCCESS,
  BULK_APPROVE_ASSIGNMENTS_FAILURE,
  BULK_REJECT_ASSIGNMENTS_REQUEST,
  BULK_REJECT_ASSIGNMENTS_SUCCESS,
  BULK_REJECT_ASSIGNMENTS_FAILURE,
  SET_PACKAGE_ASSIGNMENT_BACK_DETAILS
} from '../actions/packageAssignment';

const initialState = {
  // Package assignment list
  packageAssignmentList: [],
  packageAssignmentPageInfo: {
    TotalRecords: 0,
    PageIndex: 1,
    PageSize: 30
  },
  packageAssignmentStatus: 'idle', // 'idle', 'pending', 'success', 'failure'
  packageAssignmentError: null,

  // Company/seller record counts from the list API (null until available)
  companySellerCounts: null,
  isCompanySellerCountsDateFiltered: false,

  // Individual approval/rejection
  approvalStatus: 'idle',
  approvalError: null,
  rejectionStatus: 'idle',
  rejectionError: null,

  // Bulk operations
  bulkApprovalStatus: 'idle',
  bulkApprovalError: null,
  bulkRejectionStatus: 'idle',
  bulkRejectionError: null,

  // Navigation back details
  packageAssignmentBackDetailsObj: {}
};

const packageAssignmentReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get package assignment list
    case GET_PACKAGE_ASSIGNMENT_LIST_REQUEST:
      return {
        ...state,
        packageAssignmentStatus: 'PENDING',
        packageAssignmentError: null
      };

    case GET_PACKAGE_ASSIGNMENT_LIST_SUCCESS:
      return {
        ...state,
        packageAssignmentStatus: 'SUCCESS',
        packageAssignmentList: action.payload.list,
        packageAssignmentPageInfo: action.payload.pageInfo,
        companySellerCounts: action.payload.companySellerCounts ?? null,
        isCompanySellerCountsDateFiltered: !!action.payload.isDateFiltered,
        packageAssignmentError: null
      };

    case GET_PACKAGE_ASSIGNMENT_LIST_FAILURE:
      return {
        ...state,
        packageAssignmentStatus: 'FAILED',
        packageAssignmentList: [],
        packageAssignmentError: action.payload
      };

    // Approve package assignment
    case APPROVE_PACKAGE_ASSIGNMENT_REQUEST:
      return {
        ...state,
        approvalStatus: 'pending',
        approvalError: null
      };

    case APPROVE_PACKAGE_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        approvalStatus: 'success',
        approvalError: null
      };

    case APPROVE_PACKAGE_ASSIGNMENT_FAILURE:
      return {
        ...state,
        approvalStatus: 'failure',
        approvalError: action.payload
      };

    // Reject package assignment
    case REJECT_PACKAGE_ASSIGNMENT_REQUEST:
      return {
        ...state,
        rejectionStatus: 'pending',
        rejectionError: null
      };

    case REJECT_PACKAGE_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        rejectionStatus: 'success',
        rejectionError: null
      };

    case REJECT_PACKAGE_ASSIGNMENT_FAILURE:
      return {
        ...state,
        rejectionStatus: 'failure',
        rejectionError: action.payload
      };

    // Bulk approve assignments
    case BULK_APPROVE_ASSIGNMENTS_REQUEST:
      return {
        ...state,
        bulkApprovalStatus: 'pending',
        bulkApprovalError: null
      };

    case BULK_APPROVE_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        bulkApprovalStatus: 'success',
        bulkApprovalError: null
      };

    case BULK_APPROVE_ASSIGNMENTS_FAILURE:
      return {
        ...state,
        bulkApprovalStatus: 'failure',
        bulkApprovalError: action.payload
      };

    // Bulk reject assignments
    case BULK_REJECT_ASSIGNMENTS_REQUEST:
      return {
        ...state,
        bulkRejectionStatus: 'pending',
        bulkRejectionError: null
      };

    case BULK_REJECT_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        bulkRejectionStatus: 'success',
        bulkRejectionError: null
      };

    case BULK_REJECT_ASSIGNMENTS_FAILURE:
      return {
        ...state,
        bulkRejectionStatus: 'failure',
        bulkRejectionError: action.payload
      };

    // Set back details
    case SET_PACKAGE_ASSIGNMENT_BACK_DETAILS:
      return {
        ...state,
        packageAssignmentBackDetailsObj: action.payload
      };

    default:
      return state;
  }
};

export default packageAssignmentReducer;